import { Edge } from "@atlaskit/pragmatic-drag-and-drop-hitbox/types";
import { Box } from "@zenchef/styled-system/jsx";
import { aromaDraggableSignifier } from "@zenchef/styled-system/recipes";

const Signifier = ({ edge }: { edge: Edge }) => {
  const classes = aromaDraggableSignifier({ edge });
  return (
    <Box className={classes.wrapper}>
      <Box className={classes.ring} />
      <Box className={classes.line} />
      <Box className={classes.ring} />
    </Box>
  );
};

export default Signifier;
